@layer module {
.filter-dates__error {
            flex-shrink: 0;
            white-space: nowrap;
    }

.filter-dates__label {
            flex-shrink: 0;
            cursor: pointer;
    }

.filter-dates__group {
            display: flex;
            flex-shrink: 0;
            align-items: center;
    }
} // layer module










@layer app {
.filter-dates__group {
            gap: $size-8;
    }

.filter-checkbox-group-container {
            border-radius: $size-10;
            padding: $size-14 $size-20;
    }

.filter-dates__error {
            color: var(--color-error-text);
            font-size: var(--font-size-xs);
    }

.filter-dates__label {
            color: var(--text-secondary);
    }

.filter-dates__arrow {
            color: var(--text-faint);
    }

.filter-checkbox-group-container {
            border: 1px solid var(--border-default);
            background-color: var(--bg-surface);
    }
} // layer app
